angular.module('iqxCore')
.controller('CandidateDepartmentCtrl', function ($scope, $routeParams, $location, FormSvc, ApplicationSvc) {

  $scope.DeptID=$routeParams.departmentid  
  
  $scope.showCancelButton=true  // Show the Cancel button even though we are in autoEdit mode

  FormSvc.setOptions($scope,{
    fetchAPI:'callresult/NetCandidateRegistration?pDepartmentID='+$scope.DeptID,
    saveAPI:'call/NetCandidateDepartmentRegister',
    fetchWithPersonID:true,
    savewWithPersonID:true,
    savePrefix:'p',
    booleanFields:['temp','perm'],
    primaryKey:'personid',
    autoEdit:true, // Switch form straight to edit mode
    saveCleanFields:true,
    questionnaire:{
      tagTarget:'tags',
      id:ApplicationSvc.currentUser.personID,
      tagLocation:'A'+$scope.DeptID,
      postVar:'qanswers',
      displayGroup:'?CANDDEPT_'+$scope.DeptID
      }
    })
    
  $scope.update=function () {  // Over-ride the default update() called by form submit
    return FormSvc.update($scope,true)  // Save only - do not do the fetch
      .then(function(res) {
        FormSvc.alert("Updated", "Your department preferences have been saved.", "success")
        ApplicationSvc.isEditing=false
        $location.path('/canddepartments')  // Back to all departments
      })
    }
      
  $scope.reset=function () {  // Over-ride the default reset() called by cancel
    ApplicationSvc.isEditing=false
    $location.path('/canddepartments')  // Back to all departments
    }
      
	$scope.fetch()
  })